//import * as htmlToImage from 'html-to-image';
//import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { analyzeImage
       } from '../util/aiMain';
import { TFMem,
		 sleep } from '../util/tools'
import { StoreSession,
		 StoreVideoFile,
		 StoreHistoryBucket, 
		 StoreConsoleLogBucket,
		 UpdateSession} from '../util/database'
import { initAnalyzer,
		 closeAnalyzer,
		 analyzeBall } from '../util/analysis'
import { HISTORY,
		 INFO,
		 TIMES,
		 CONSTS,
		 REACT_STATES,
		 STATS } from '../util/object'
import { displayBlock, displayGridLines } from '../util/annotate'
import { UtilClass } from '../class/UtilClass';
import { CameraClass } from '../class/CameraClass';
import { timeDelta,
		 setFrameEvent,
         NOW,
		 } from '../util/util'
import { GATag, Stack } from "../util/tools";
//import * as tf from '@tensorflow/tfjs';
//import * as Posenet from '@tensorflow-models/posenet';
//const tus = require('tus-js-client');


/////////////////////////////////////////////////////////////////////////////////////////////////////////
////
//// WEBCAM RELATED ROUTINES
//// src: https://github.com/elizabethsiegle/posenetTwilioVideoTensorFlowjs/blob/master/assets/video.js
////

var localStream;
var vidIntervalID = null;
//var videoStopped = true;
var videoEnded = false;
const Util = new UtilClass();

const webcam_constraints = {
  video: true,
  audio: false
};

var movenet_video_config = {
	'audio': false,
	'video': {
		facingMode: 'user',
		//width: Util.isMobile() ? 360 : 640, // use default for mobile devices
		//height: Util.isMobile() ? 270 : 480,
		width: {ideal: INFO.webcam_owidth},
		height: {ideal: INFO.webcam_oheight},
		frameRate: { ideal: 30 }        // was 20
	}
};


function webcamHandleSuccess(stream) {
	var video = document.querySelector('video');
    if (!video) return;

	video.srcObject = stream;
	localStream = stream;       // KLUDGE: GLOBAL!
	window.stream = stream; // make variable available to browser console

	const videoTracks = stream.getVideoTracks();
	console.log("vid.73:  Using video device: ",videoTracks[0].label);      // , "  stream=",stream);
	video.setAttribute('playsinline', '');
    INFO.webcam_stream = stream;

	var height = parseInt(video.getAttribute('height'));
	var width = parseInt(video.getAttribute('width'));
	INFO.video_owidth = width;			// orig video file aspect ratio, this chgs later
	INFO.video_oheight = height;		// orig video file aspect ratio, this chgs later

	var vcanvas = document.getElementById("vcanvas");
	vcanvas.height = height;
	vcanvas.width = width;

	var ocanvas = document.getElementById("output");
	ocanvas.height = height;
	ocanvas.width = width;

	//vcontext.translate(vcanvas.width, 0); 
	//context.translate(canvas.width, 0); 
	console.log("wecam_success.85:  getUserMedia DONE...o.width=", ocanvas.width, "  o.height=", ocanvas.height);

	if(INFO.webcam_running == true) {
		console.log("wecam_success.92:  START WEBCAM Display NOW... now=",Date.now()%100000/1000)
		drawWebcamScreen();
	}
}



function webcamHandleError(error) {
	var err_msg;

	if (error.name === 'ConstraintNotSatisfiedError') {
		const v = webcam_constraints.video;
		console.log("The resolution "+v.width.exact+"x"+v.height.exact+" px is not supported by your device.");
		err_msg = "ERROR: RESOLUTION NOT SUPPORTED BY WEBCAM ("+ v.width.exact+" x "+v.height.exact+")";
        GATag("Webcam", "Error.Rez", INFO.session_name, 0);		 // (cat, act, lab, val)
	} else if (error.name === 'PermissionDeniedError') {
		console.log('Permissions have not been granted to use your camera and ' +
		'microphone, you need to allow the page access to your devices in ' +
		'order for the demo to work.');
		err_msg = "ERROR: NO PERMISSION TO ACCESS WEBCAM ";
        GATag("Webcam", "Error.Perm", INFO.session_name, 0);		 // (cat, act, lab, val)
	} else {
		//err_msg = "ERROR: THIS BROWSER DOES NOT SUPPORT WEBCAM, TRY A DIFFERENT BROWSER  ";
		err_msg = "ERROR: RESTART WITH HTTPS:// TO ACCESS WEBCAM"
        GATag("Webcam", "Error.HTTPS", INFO.session_name, 0);		 // (cat, act, lab, val)
	}
	console.log(`getUserMedia ERROR:+ ${error.name}`, error);
	console.log("getUserMedia.109 ERROR: ", error.name," ", error);

	INFO.warning_message = err_msg;
	window.dispatchEvent(INFO.show_warning_event);       // tell UI to show error msg
	return;

}

// vvvvvvvvvvvvvvvvvvvvvvvvv BELOW CODE MOVE SOMEWHERE ELSE? vvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
// MAIN: Process LOOP - Repleases  analyzeImage()?
//      - DEMO OBJECT CODE...NOT INTEGRATED, PROTOTYPE WORKS, TO FIGURE OUT SKELETON OFFSET
// XXCD 
async function renderResult() {
    /* ******************** NOT CURRENTLY USED ********************
    */
}


// NEW MAIN ANALYSIS -> RENDER LOOP
//
async function renderPrediction() {
	if(INFO.webcam_running == true) {
		await renderResult();
		INFO.animation_id = requestAnimationFrame(renderPrediction);
	} else {
		console.log("new_predict.161: ------------- PREDICTION LOOP STOPPED");
	}
};
// ^^^^^^^^^^^^^^^^^^^^^^^^^ ABOVE CODE MOVE SOMEWHERE ELSE? ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^


// UTIL: check the supported webcam modes for this device
//
export async function probeWebcamDim(e) {
        // DEBUG: Detect resolution
        var CAM_WIDTH0 = [160, 240, 640, 800, 1024, 1280, 1280, 1600, 1920, 2048];      // wide screen
        var CAM_HEIGHT0 = [120, 160, 360, 480, 768, 720, 962, 1200, 1080, 1536];

        var CAM_WIDTH = [320, 360, 640, 800, 960];   // narrow aspect = 1.33
        var CAM_HEIGHT = [240, 270, 480, 600, 720];     // limit is ht <= 720
        var cam_config = {}
        cam_config.video = {}
        cam_config.audio = false;
        for (var i = 0; i < CAM_WIDTH.length; i++) {
            var wd = CAM_WIDTH[i];
            var ht = CAM_HEIGHT[i];
            cam_config.video.width =  {"ideal": wd};
            cam_config.video.height =  {"ideal": ht};

            let stream0 = await navigator.mediaDevices.getUserMedia(cam_config);
            var actual = stream0.getVideoTracks()[0].getSettings();
            console.log("webcam.172:    WEBCAM DIM:    IDEAL: wd=", wd, " ht=",ht, "   ACTUAL: wd=",actual.width, " ht=",actual.height, " ratio=",(actual.width/actual.height).toFixed(2));
            stream0.getTracks()[0].stop();
            await sleep(50);
        }
}


// Creates webcam source media stream
//
async function startUserMedia(e) {
	try {
		//const stream = await navigator.mediaDevices.getUserMedia(webcam_constraints);
        movenet_video_config.video.width =  {ideal: INFO.webcam_owidth};
        movenet_video_config.video.height =  {ideal: INFO.webcam_oheight};
        console.log("webcam.200:       START_USER_MEDIA   BEFORE:    wd=",INFO.webcam_owidth, "  ht=",INFO.webcam_oheight, "  cfg=",movenet_video_config);


		const stream = await navigator.mediaDevices.getUserMedia(movenet_video_config);
		var stream_settings = stream.getVideoTracks()[0].getSettings();
		INFO.webcam_owidth = stream_settings.width;     // actual
		INFO.webcam_oheight = stream_settings.height;   // actual

        // set up scaling factor with actual webcam dimension
        //
        const cw = CONSTS.WEBCAM_BASE_WIDTH_FN();    // 640;     // was 360
        const ch = CONSTS.WEBCAM_BASE_HEIGHT;   // 360;     // was 270
        const ww = INFO.webcam_owidth;
        const wh = INFO.webcam_oheight;
        const xx = ww / cw;
        const yy = wh / ch;
        INFO.scale_x = xx;
        INFO.scale_y = yy;
        INFO.scale_font = (ww * wh) / (cw * ch);
        INFO.scale_dist = Math.sqrt((ww * ww) + (wh * wh)) / Math.sqrt((cw * cw) + (ch * ch));
        INFO.webcam_aspect = Math.floor(ww / wh * 1000) / 1000;
        console.log("init_webcam_dim.200:    WEB CAM RESOLUTION:    webcam_owidth=",parseInt(INFO.webcam_owidth), "  webcam_oheight=",INFO.webcam_oheight);
        console.log("init_webcam_dim.201:                           scale_x=",INFO.scale_x.toFixed(2), "  scale_y=",INFO.scale_y.toFixed(2), "  scale_font=",INFO.scale_font.toFixed(2), "  scale_dist=",INFO.scale_dist.toFixed(2));
        console.log("init_webcam_dim.201:                           cw =", CONSTS.WEBCAM_BASE_WIDTH_FN());


        INFO.video_width = INFO.webcam_owidth;      // for storing the video dim
        INFO.video_height = INFO.webcam_oheight;
        var output = document.getElementById('output'); 
        if (output) {
            output.setAttribute("width", INFO.video_width+"px");
            output.setAttribute("height", INFO.video_height+"px");
        }

        var output1 = document.getElementById('vcanvas'); 
        if (output1) {
            output1.setAttribute("width", INFO.video_width+"px");
            output1.setAttribute("height", INFO.video_height+"px");
        }
        console.log("webcam.117:  START WEBCAM STREAM SIZE    wd=",INFO.webcam_owidth, "  ht=",INFO.webcam_oheight, "  cfg=",movenet_video_config);

		webcamHandleSuccess(stream);
	} catch (e) {
		webcamHandleError(e);
	}
}



export function getHistoryObject(){
	var hist = {}
	var output = {}
	for(var i=0; i< HISTORY.length; i++) {
		var history = HISTORY[i];
		output[Math.floor(history.timestamp)] = history;
		//console.log(i+": ",output);
	}
	console.log("hist.104:  TOTAL HISTORY.len=",HISTORY.length);
	return output;
}


// if in interrupt mode, just stop the camera
//
export function disableWebcamStream() {
        console.log("webcam.205:        # # # #  TRY TO FORCE STOP WEBCAM .....  localStream=",(localStream) ? true : false);
        if(localStream !== undefined) {
            localStream.getTracks()[0].stop();
        }
}


// MAIN ENTRY: used by challenge to start webcam and AI analysis
//     - Controls webcam
//     - Turns on AI analysis
//     - Controls video recording at the end
//
// ref: poseDetection.calculator.keypointsToNormalizedKeypoints(keypoints, imageSize)
export async function initWebcamAI(junk, turn_on, from) {

    console.log("webcam.218:  # # # # # # # # # # #  START WEBCAM AI INIT.....  ON=",turn_on,"    from=",from);
	if ((turn_on == false) && (INFO.webcam_running == false)) {
		console.log("webcam.143:        ! ! ! ! ! ! !  WEBCAM ALREADY STOPPED!  from=",from);
		return;
	}

	//var video = document.querySelector('video');
	//var vcanvas = document.getElementById("drill_output");
    //console.log("initWebcamAI.214:   video=",video, " vcanvas=",vcanvas);
	var video = document.getElementById("video");
	if (video == null) { // WARNING: chk canvas null here will get into loop?
		console.error("webcam.228:         ! ! ! ! ! ! ! !    ABORT, NO WEBCAM VIDEO ELEMENT  from=",from);
		return;		// not ready;
	}

	//var canvas = document.getElementById(INFO.analysis_canvas);
	var canvas = document.getElementById("vcanvas");
	var ctx = canvas.getContext("2d");
    INFO.file_name = INFO.session_name;

	if(turn_on == false) {

        // TURN OFF WEBCAM
        //
		INFO.webcam_running = false; 
		TIMES.webcam_stop = Date.now();
		console.log("webcam.321:   # # # # # # # # TURN OFF WEBCAM!!!  from=",from, " now=",TIMES.webcam_stop/1000);
        INFO.show_results = false;      // turn it off

		if (INFO.use_camera_object == true) {
            console.log("webcam.235:  -  -  -  - WEBCAM OBJECT STOPPED");
			INFO.webcam.stopCamera();
		} else {
			video.pause();
			video.src = "";
			if(INFO.webcam_stream) {
                console.log("webcam.305:  -  -  -  - WEBCAM PAUSED");
                INFO.webcam_stream.getTracks()[0].stop();
			}

			// when bucket write it complete it will send an event that does the firestore write
			if(INFO.interrupted_mode == false) {
				if(INFO.record_running == true) {
					setTimeout(()=> {
						console.log("webcam.326:  * * * * * * WOKE UP, stop recording...", Date.now()%100000/1000);
						recordOutput(INFO.analysis_canvas, "stop.ai.webcam", false);		// stop recording if it's running
					}, 500)
				}

                INFO.db_store_started = true;
                INFO.db_store_completed = false;
				setTimeout(()=> {
					console.log("webcam.250:  * * * * * * WOKE UP, write console log...", Date.now()%100000/1000);
					StoreConsoleLogBucket(INFO.email, INFO.uid);
				}, 3000)
				var hist = StoreHistoryBucket(INFO.email, INFO.uid, "practice");
			}
		}

		return;
	} else {

        // TURN ON WEBCAM
        //
		INFO.webcam_running = true;
		TIMES.webcam_start = Date.now();
		console.log("webcam.283:    # # # # # # START TO TURN ON WEBCAM!!!  from=",from," name=",INFO.file_name," start=", TIMES.webcam_start/1000, " now=",Date.now()%100000/1000);

		video.style.display = "block";		// must show video element
		video.style.visibility = "visible";	// must show video element
		video.style.position = "absolute";
		video.style.zIndex = "-1000";			// hide behind
		video.style.width = "1px";			// hide behind
		video.style.height = "1px";			// hide behind

		//canvas.style.display = "none";
		//canvas.style.visibility = "hidden";

		// NOTE: cameraClass() object is better architecture, but this code not yet fully supports it!
        //
		if (INFO.use_camera_object == true) {
			if(INFO.webcam == null) {
				var cameraParams = {targetFPS: 60, sizeOption: '640 X 480'};
				INFO.webcam = await CameraClass.setupCamera(cameraParams);		// returns a new obj
			}
			renderPrediction();		// new cameraClass() analysis->render loop

		} else {
			startUserMedia();       // XXCD: main path
		}
	}

	video.addEventListener('loadedmetadata', function() {
		//var ctx = video.getContext("2d");
		//ctx.translate(video.videoWidth, 0); 
		//ctx.scale(-1, 1);
		var height = video.videoHeight;
		var width = video.videoWidth;
        INFO.video_width = width;
        INFO.video_height = height;
		console.log("webcam.233:  ********* onLoadedMedia DONE...  vid.width=", width, "  vid.height=", height, " now=",Date.now()%100000/1000);

	});
}


// MAIN: Drill AI_ananlysis => Render loop
//     - entered from startUserMedia() => webcamHandleSuccess()
// XXCD
async function drawWebcamScreen () {
	var hidx = HISTORY.length - 1;

	if (INFO.webcam_running == false) {
		console.log("drawWebCamScreen.95:  * * * * * Video Image Detection STOPPED  now=",Date.now()%100000/1000);
		return;
	}

	var video = document.getElementById("video");       // incoming video
	//var vcanvas = document.getElementById("vcanvas");   // this is staging canvas to avoid flicker
	var vcanvas = document.getElementById(INFO.analysis_canvas);   // this is staging canvas to avoid flicker
	if((vcanvas == null) || (video == null)) {
		console.error("drawWebCamScreen.337:  ! ! ! ! !  NO VCANVAS OR VIDEO  vacanvas=",vcanvas, " video=",video);
		return;
	}

	var vctx = vcanvas.getContext("2d");
	const width = parseInt(vcanvas.width);	// 320 px
	const height = parseInt(vcanvas.height);	// 240 px
	const offsetHeight = parseInt(vcanvas.offsetHeight);	// 240 px
    var vidRatio = video.videoWidth / video.videoHeight;
	if(width == 0) {
		console.error("drawWebCamScreen.347:  ! ! ! ! !  ZERO VIDEO WIDTH");
		return;
	}

    var t0 = Date.now();    //const t0 = performance.now();
    if (!TIMES.inference_completed || (TIMES.inference_completed > TIMES.inference_started)) {
        //console.log("drawWebCamScreen.349:         * * * * * START DRAW LOOP  hidx=",hidx, " now=",parseInt(t0), "  LAST started=", parseInt(TIMES.inference_started), " done=", parseInt(TIMES.inference_completed), " delta=",parseInt(delta));
        const quantum = 50;     //100;
        if (((hidx + 2) % quantum) == 0) {
            if (TIMES.fps_time > 0) {
                TIMES.per_frame_time = (t0 - TIMES.fps_time) / quantum;
                var fps = Math.floor((1000 / TIMES.per_frame_time) * 100) / 100;
                console.log("fps.433: =============>>>>  CURRENT FPS=", fps, "  <<<<=============== hidx=",hidx, " t0=",t0%100000/1000, " t1=",TIMES.fps_time%100000/1000, " per_frame=",parseInt(TIMES.per_frame_time));

                INFO.current_fps = fps;
                if ((INFO.skip_ball_detect == false) && (fps < CONSTS.MIN_FPS)) {
                    console.log("fps.337: =======>>>>  DEGRADE TO NO BALL AI FPS =", fps, " duration=", TIMES.per_frame_time, "  t0=",t0);
                    INFO.skip_ball_detect = true;	// one way trip
                }
            }
            TIMES.fps_time = t0;
        }
        TIMES.current_frame = t0;
    }


    var ocanvas = document.getElementById("output");   // output display canvas
    var octx = ocanvas.getContext("2d");
    //octx.clearRect(0, 0, width, height);    // BAD: MESSES UP AI!!!  clear out prev final annotated canvas
    //vctx.clearRect(0, 0, width, height);    // BAD: MESSES UP AI!!!
    vctx.drawImage(video, -width, 0, width, height);		// XXCD: first draw the flipped video image, then add AI annotation
    vctx.scale(-1, 1);

    var success = await analyzeImage(vcanvas, t0);	// Run AI Inference and show annotations on vcanvas
    octx.drawImage(vcanvas, 0, 0, width, height);		// transfer annotated video to output canvas

    if (success === true){
        //console.log("drawWebCamScreen.386:                   - NEW POSE DETECTED   started=", parseInt(t0));
        if (INFO.show_defender === true) {
            var defender = document.getElementById("defender");   // merging in defender
            var ctx2 = (defender) ? defender.getContext('2d') : null;
            if (defender && (ctx2.width > 0) && (ctx2.height > 0)) {
                octx.drawImage(defender, 0, 0, width, height);		// layer on defender on a semi-transparent context
                //console.log("defend.386:    defender  width=",ctx2.width, " height=",ctx2.height, " defender=",defender);
            }
        }

        TIMES.inference_started = t0;
    } else {
        //console.log("drawWebCamScreen.383:                   - NEW POSE DETECT FAILED!  started=", parseInt(t0));
        TIMES.inference_completed = TIMES.inference_started;        // this pass not completed
    }

    //console.log("drawWebCamScreen.316:  * * * * * SKIP FRAME, LAST AI INFERENCE TOO SLOW  started=", parseInt(TIMES.inference_started), " completed=", parseInt(TIMES.inference_completed));

    var t1 = Date.now();
    const delta = t1 - t0;
	if (INFO.webcam_running == true) {
        var delay = CONSTS.MAX_ANIMATION_MSEC - delta;
        if (delay > 0) {
            //console.log("fps.414:                 . . . ANIMATION DELAY  delay=", delay, " delta=",delta,"  hidx=",hidx, " t0=",t0%100000/1000, " t1=",t1%100000/1000);
            setTimeout(()=> { 
                requestAnimationFrame(drawWebcamScreen);		// throttle if needed
            }, delay);  
        } else {
            requestAnimationFrame(drawWebcamScreen);		// too slow already, no delay
        }
	}
}




// UTIL: DEVELOPER VIDEO AI_ananlysis => Render loop
//     - allows vimeo recording of other videos (must be from a native player!  no youtube or vimeo source)
//
// XXCD
export async function drawVideoScreen(mode, from) {
	var hidx = HISTORY.length - 1;
    var paused = false, input = null, vcanvas = null;
    var webcam = false, vtime = null;
    if (!mode) mode = INFO.dev_record_mode;     // not remember if this is a callback

	var output = document.getElementById("output");         // AI annotated display canvas
    input = document.getElementById("drill_output");       // video source stream
    if (!input) {
        vcanvas = document.getElementById("vcanvas");       // webcam temp working canvas
        input = document.getElementById("video");       // webcam source stream
        webcam = true;
    } else {
        vcanvas = document.getElementById("vcanvas");       // webcam temp working canvas
        //vcanvas = output;
        webcam = false;
    }

	if((output == null) || (input == null)) {
        console.error("drawVideo.406:      ! ! ! ! ! ERROR:  BAD input",input, " ouput=",output, " from=",from, " mode=",mode);
		return;
	}
    //console.log("drawVideo.432:    # # # # # # #  START Draw ANAL Video Screen    from=",from, " canvas=", output, " video=",video, " o.w=", output.width, " o.h=",output.height, " dev_video_stopped=",INFO.dev_video_stopped);

	var octx = output.getContext("2d");
	var vctx = vcanvas.getContext("2d");
	const width = vcanvas.width;	// 320 px, was: output.width
	const height = vcanvas.height;	// 240 px
	if(width == 0) {
        console.log("drawVideo.439:      . . . . . NO WIDTH!!!!   Drawing output  mode=",INFO.dev_record_mode, " out.wd=", width, "  out.ht=",height, " output=",output, " input=",input);
		return;
	}

	if(INFO.dev_video_stopped == true) {
		console.log("drawVideo.445: ! ! ! !  Video Render Loop STOPPED  mode=",mode, " from=",from);
		return;
	}

    // support AI video stepping
    //    - If time frame is different then show new analyzed frame
    //    - If video is paused then do not analyzeImage()
    //    - Do show the last analyzed frame
    //
    //var paused0 = INFO.learn_player.paused;     // KLUDGE: SHOULD NOT CALL PLAYER FROM THIS LEVEL!
    //if (paused0 === true)  paused = true;

    paused = false;
    if (webcam === false) {
        vtime = INFO.learn_player.getTime();        // KLUDGE: SHOULD NOT CALL PLAYER FROM THIS LEVEL!
        // need to sync with video player state
        //
        if (INFO.last_video_time !== null) {
            if (vtime === INFO.last_video_time)  {
                paused = true;
            } else {
                INFO.last_video_time = vtime;
            }
        } else {
            INFO.last_video_time = vtime;
            //console.log("drawVideo.506:    RUNNING-2  delta=",(vtime - INFO.last_video_time).toFixed(3), " paused=",paused, "    vtime=",vtime, "    prev=",INFO.last_video_time);
        }
    }

    // calc FPS
    //
	const quantum = 80;
	if((hidx > 0) && ((hidx % quantum) == 0)) {
		if(TIMES.fps_time > 0) {
			TIMES.per_frame_time = (t0 - TIMES.fps_time) / quantum;
			var fps = Math.floor((1000 / TIMES.per_frame_time) * 100)/100;
			console.log("fps.495: =============>>>>  CURRENT FPS=", fps, "  <<<<===============", " mode=",mode, " from=",from);
            INFO.current_fps = fps;
			if ((INFO.skip_ball_detect == false) && (fps < CONSTS.MIN_FPS)) {
				console.log("fps.498: =======>>>>  DEGRADE TO NO BALL AI FPS =", fps, " duration=", TIMES.per_frame_time, "  t0=",t0);
				INFO.skip_ball_detect = true;	// one way trip
			}
		}
		TIMES.fps_time = t0;
	}
	TIMES.current_frame = (vtime * 1000);        // use the video time (not wall clock elapse time)
    //console.log("drawVideo.520:    current=",TIMES.current_frame, "  start=",TIMES.start_run,   " delta=", (TIMES.current_frame - TIMES.start_run));

        //console.log("drawVideo.451:    # # # # # # #  Draw Video Screen     o.w=", width, " o.h=",height, " vid.stopped=",INFO.dev_video_stopped);
        //octx.clearRect(0, 0, width, height);    // need this!
        if (webcam === true) {
            vctx.drawImage(input, -width, 0, width, height);		// XXCD: first draw the flipped video image, then add AI annotation
            vctx.scale(-1, 1);
        } else {
            if (paused === false) {
                //octx.drawImage(input, 0, 0, width, height);		// XXCD: first draw the video image, then add AI annotation
                vctx.drawImage(input, 0, 0, width, height);		// XXCD: first draw the video image, then add AI annotation
            }
        }

	var t0 = Date.now(); 
    if(mode === "ai") {
        // do not analyze if on the same video frame
        //
        //console.log("ai.535:       . . . . CALLING AI  analyzeImage()  webcam=",webcam, " wd=",width, " ht=",height, " output=",output, " vacanvas=",vcanvas);
        if (webcam === true) {
            await analyzeImage(vcanvas, TIMES.current_frame);	// XXCD: KEY STARTING POINT FOR ANALYSIS (works)
            octx.drawImage(vcanvas, 0, 0, width, height);		// Transfer final annotated video to output canvas
        } else {
            if (paused === false) {
                //await analyzeImage(output, TIMES.current_frame);	// XXCD: KEY STARTING POINT FOR ANALYSIS (works)
                //octx.drawImage(vcanvas, 0, 0, width, height);		// Transfer final annotated video to output canvas
                await analyzeImage(vcanvas, TIMES.current_frame);	    // XXCD: KEY STARTING POINT FOR ANALYSIS (works)
                octx.drawImage(vcanvas, 0, 0, width, height);		// Transfer final annotated video to output canvas
            }
        }

        if(INFO.dev_video_stopped === false) {
            requestAnimationFrame(() => {drawVideoScreen(INFO.dev_record_mode, (from))});   //+"+draw.ai.533"))});		// daisy chain next draw
        } else {
            console.log("ai.482:       ! ! ! ! ! AI DEV VIDEO STOPPED   stopped=,",INFO.dev_video_stopped, " mode=", mode, " from=",from);
        }
    } else {

        // no AI
        //
        octx.drawImage(vcanvas, 0, 0, width, height);		// Transfer final annotated video to output canvas
        setTimeout( () => {
            if(INFO.dev_video_stopped === false) {
                requestAnimationFrame(() => {drawVideoScreen(INFO.dev_record_mode, (from))}); //+"+draw.noai.544"))});		// daisy chain next draw
            } else {
                console.log("ai.492:       ! ! ! ! ! NO-AI DEV VIDEO STOPPED   stopped=,",INFO.dev_video_stopped, " mode=",mode, " from=",from);
            }
        }, 50);     // if no AI, throttle to 20 FPS
    }

}




// UTIL: Copy div to a canvas so it can be recorded to vimeo
//     - this allows us to record whatever is on the screen to make intro (game, mock)
//
// Note: Note quite working, need to figure out the <div> => <canvas>
//
// XXCD
export async function copyDivScreen(mode, from) {
	var hidx = HISTORY.length - 1;
    var paused = false, input = null, vcanvas = null;
    var webcam = false, vtime = null;
    if (!mode) mode = INFO.dev_record_mode;     // not remember if this is a callback

	var output = document.getElementById("output");         // AI annotated display canvas
    var input = document.getElementById("drill_output");       // video source stream
    var div = document.getElementById("target0");       // webcam temp working canvas

	if((output == null) || (input == null)) {
        console.error("copyDiv.406:      ! ! ! ! ! ERROR:  BAD input",input, " ouput=",output, " from=",from, " mode=",mode);
		return;
	}
    //console.log("copyDiv.632:    # # # # # # #  START Copy DIV to Output Screen    from=",from, " canvas=", output, " o.w=", output.width, " o.h=",output.height, " dev_video_stopped=",INFO.dev_video_stopped);

	var octx = output.getContext("2d");
	var ictx = input.getContext("2d");
	const width = input.width;
	const height = input.height;
	if (width == 0) {
        console.log("copyDiv.639:      . . . . . NO WIDTH!!!!   Drawing output  mode=",INFO.dev_record_mode, " out.wd=", width, "  out.ht=",height, " output=",output, " input=",input);
		return;
	}

	if (INFO.record_output == false) {
		console.log("copyDiv.645: ! ! ! !  Div Copy Loop STOPPED  mode=",mode, " from=",from);
		return;
	}


    if (true) {
        /* src: http://html2canvas.hertzen.com/       << not work, converts to canvas is too heavy
        import html2canvas from 'html2canvas';
        html2canvas(div, {
            onrendered: function (divCanvas) {
                ictx.drawImage(divCanvas, 0, 0, width, height);
            }
        }); /**/

        /* src: https://www.npmjs.com/package/html-to-image  << converts to svg
        function filter (node) { return (node.tagName !== 'i'); }
        htmlToImage.toSvg(div, { filter: filter })
        .then(function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            img.onload = function() { ictx.drawImage(img, 0, 0); }
        }); /**/

        INFO.out_context = ictx;
        displayBlock("red", 100, 100, 20, 20);
        octx.drawImage(input, 0, 0, width, height);		// XXCD: first draw the video image, then add AI annotation

        setTimeout( () => {
            if(INFO.record_output === true) {
                requestAnimationFrame(() => {copyDivScreen(INFO.dev_record_mode, (from))}); //+"+draw.noai.544"))});		// daisy chain next draw
            } else {
                console.log("ai.492:       ! ! ! ! ! COPY DIV RECORDING STOPPED   stopped=,",INFO.div_recording_stopped, " mode=",mode, " from=",from);
            }
        }, 50);     // if no AI, throttle to 20 FPS
    }

}






/////////////////////////////////////////////////////////////////////////////////////////////////////////
// RECORD VIDEO TO FILE CODE
//
// store blob from video canvas into video file
// src: https://github.com/webrtc/samples/blob/gh-pages/src/content/getusermedia/record/js/main.js
var mediaRecorder = null;
var recordedBlobs = [];
var img_name;
export function downloadFile() {


    //if (INFO.record_mode === true) {console.log("KLUDGE.551: ***** DOWNLOAD DISABLED!!!"); return;}     // SUPER KLUDGE


	//var [ formats, codecs ] = supportedVideoFormat();
	//var format = formats[0];
	//var codec = codecs[0];
	const blob = new Blob(recordedBlobs, {type: "video/" + INFO.video_format});
	const url = window.URL.createObjectURL(blob);

	if (INFO.interrupted_mode === false) {
        console.log("vrec.232:  # # # #  SAVING VIDEO   blob.size=",blob.size, " admin=",INFO.admin_mode, " recording=",INFO.record_running, " interrupted=",INFO.interrupted_mode);
        if((INFO.admin_mode == false) || (INFO.record_running == true)) {
            console.log("vrec.227:          . . . .  VIDEO BLOB  ", recordedBlobs, " size=",blob.size);

            StoreVideoFile(INFO.email, INFO.uid, blob)
            .then(() => {
                recordedBlobs = [];
            })
            .catch((err) => {
                console.log("vrec.376: ERROR: "+err.message);
            })

        } else {

            // store on pc for admin mode
            //
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = "new_"+img_name+"."+INFO.video_format;
            document.body.appendChild(a);

            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                recordedBlobs=[];	// reset for next one
            }, 1000);
        }
    } else {
        console.log("vrec.576:    ! ! ! !   INTERRUPTED - NO VIDEO SAVING");
    }
}



export function recordOutput(canvas_name, file_name, start) {
	var record_canvas = document.getElementById(canvas_name);
	if ((start == true) && (INFO.record_running == true)) {
		console.log("vrec.531: TRY TO RECORD BUT STILL RECORDING file_name=", INFO.file_name);    // already recording
		return;
	}

	//INFO.analysis_canvas = canvas_name;	// why chg here?
    if (start === true) INFO.file_name = (file_name) ? file_name.toString() : "_auto_";
	console.log("vrec.172:   * * * * * * ENTER VIMEO RECORDING    start_requested=",start,"  file=", INFO.file_name,"  canvas=",canvas_name);  //, " INFO.mdeaRecorder=", INFO.media_recorder, " mediaRecroder=",mediaRecorder);
	if(mediaRecorder == null) {
		mediaRecorder = INFO.media_recorder;
	}

	if(start == false) {
		if((mediaRecorder !== null) &&
		   (mediaRecorder.state !== "inactive")) {
			mediaRecorder.stop();
            setTimeout(()=> {
                console.log("vrec.415:  * * * * * * *  TRY TO STOP RECODRING, WAITING FOR PROCESSING TO END ...  state=", mediaRecorder.state, " now=",Date.now()%100000/1000);
				if (mediaRecorder.state !== "inactive") {
					mediaRecorder.stop();       // double stop
				}
            }, 300);
		}
		return;
	} else {
		console.log("vrec.555:   * * * * * * * START Video recording requested ", Date.now()%100000/1000);
		INFO.recording_file = INFO.file_name;	// remember session name
		INFO.record_running = true;
	}

    return new Promise(function (res, rej) {
        if (!record_canvas) return;

		var success = false;
        var stream = record_canvas.captureStream(CONSTS.VIDEO_RECORD_FPS);
		var [ formats, codecs ] = supportedVideoFormat();

		// try diff codec until we succeed
		for(var i = 0; i < formats.length; i++) {
			var format = formats[i];
			var codec = codecs[i];

			try {
				mediaRecorder = new MediaRecorder(stream, {
					mimeType: 'video/'+format+'; codecs="'+codec+'"',
				});
				INFO.video_format = format;
				INFO.video_codec = codec;
				success = true;
			}
			catch (err) {
                //console.error("vrec.628:       ! ! ! ! CAPTURE ERROR:  ", err);     // intermeidate failures
			}

			if (success === true) {
				continue;
			}
		}

		if(success === false) {
			INFO.media_recorder = null;
			var err_msg = "vrec.587: !!!!!!! ERROR: INIT FAILED!   Browser does not support WEBM or MP4!";
			INFO.warning_message = err_msg;
			window.dispatchEvent(INFO.show_warning_event);       // tell UI to show error msg
		} else {
			INFO.media_recorder = mediaRecorder;
			mediaRecorder.onstop = (event) => {
				console.log('vrec.593:  * * * * * * * * RECORDING HAS STOPPED: ', "  blob.size=", recordedBlobs.length, " now=",Date.now()%100000/1000);
				downloadFile();

                INFO.media_recorder = null;     // done recording, kill it
                INFO.record_running = false;    // best place to set this
			};

			mediaRecorder.ondataavailable = handleDataAvailable;
			mediaRecorder.start();
			console.log('vrec.598:   * * * * * * * *  Video recording INITIALIZED  format=', INFO.video_format, ' codec=', INFO.video_codec);    //, ' ', mediaRecorder);
		}
    })
}

// store the recorded data in the blob
function handleDataAvailable(event) {
    //console.log('vrec.605:  . . . . . . . .   handleDataAvailable ENTER', event);
	if ((event.data !== undefined) && (event.data.size > 0)) {

		// encoded data from MediaRecorder, we can write it to blob or network storage
		//
		recordedBlobs.push(event.data);
		console.log("vrec.611: ######### handleDataAvailable state=", mediaRecorder.state, "  STORING= ", event.data.size);
	}
}

// play back the capture blob
// src: https://developers.google.com/web/updates/2016/01/mediarecorder
function playRecording() {
	var superBuffer = new Blob(recordedBlobs);
	videoElement.src = window.URL.createObjectURL(superBuffer);
}




/////////////////////////////////////////////////////////////////////////////////////////////////////////
////
//// PLAY AUDIO FILE IN CANVAS RELATED ROUTINES
////
export function playAudio(path, from) {
	//var audio = new Audio(path);
	var audio = INFO.audio;
    if (!audio) {
        console.error("audio.710:    ! ! ! ! ! ! !  NO AUDIO SETUP   from=",from, " path=",path);
        return;
    }
    console.log("audio.687:    # # # # # # # PLAY AUDIO  from=",from, " path=",path);

    audio.src = path;
	//audio.play();		// DISABLE UNTIL WE CAN FIGURE OUT THE IOS ISSUE
	const promise = audio.play();
	if (promise) {
			promise.catch((e) => {
				if (e.name === 'NotAllowedError' ||
					e.name === 'NotSupportedError') {
					console.log("audio.241: FAILED TO PLAY ", e.name, " path=",path);
				}
        });
    }
}



/**
 * Original idea from http://stackoverflow.com/questions/20267939/nodejs-write-base64-image-file
 /
//var fs     = require('fs');
//var mkdirp  = require('mkdirp');
var regex = /^data:([A-Za-z-+\/]+);base64,(.+)$/;
function b64decode (dataString, cb) {
  var matches = dataString.match(regex) || { length: 0 };

  //if(matches.length !== 3) //return cb(new Error('Invalid base64 encoded image'));

  var info    = {};
  info.type = matches[1];

  //var buffer = new Buffer.from(matches[2], 'base64');
  var buffer = Buffer.from(matches[2], 'base64');
  return buffer;
  //cb( null, info);
}
*/




// store gif inside a blob and then download it (works)
//
// https://stackoverflow.com/questions/21012580/is-it-possible-to-write-data-to-file-using-only-javascript
export function  writeGifFile(data0, file_name) {

    var buffer0 = data0.replace(/^data:image\/gif;base64,/, "");
    var buffer = Buffer.from(buffer0, 'base64');
    var data = new Blob([buffer], {type: 'image/gif'});
    //console.log("gif.613:  FINAL gif image=",data);

    // when replacing a previously generated file we need to
    // manually revoke the object URL to avoid memory leaks.
    if (filep !== null) {
		window.URL.revokeObjectURL(filep);
    }

    filep = window.URL.createObjectURL(data);
	const a = document.createElement('a');
	a.style.display = 'none';
	a.href = filep;
	//a.download = "new_"+img_name+type;  //+".csv";
	a.download = file_name;
	document.body.appendChild(a);

	a.click();
	setTimeout(() => {
		document.body.removeChild(a);
		window.URL.revokeObjectURL(filep);
		recordedBlobs=[];	// reset for next one
	}, 1000);
}



// store text inside a blob and then download it
//
// https://stackoverflow.com/questions/21012580/is-it-possible-to-write-data-to-file-using-only-javascript
var filep = null;
export function  writeTextFile(text) {
    var data = new Blob([text], {type: 'text/plain'});

    // when replacing a previously generated file we need to
    // manually revoke the object URL to avoid memory leaks.
    if (filep !== null) {
		window.URL.revokeObjectURL(filep);
    }

    filep = window.URL.createObjectURL(data);
	const a = document.createElement('a');
	a.style.display = 'none';
	a.href = filep;
	a.download = "new_"+img_name+".csv";
	document.body.appendChild(a);

	a.click();
	setTimeout(() => {
		document.body.removeChild(a);
		window.URL.revokeObjectURL(filep);
		recordedBlobs=[];	// reset for next one
	}, 1000);
}



/////////////////////////////////////////////////////////////////////////////////////////////////////////
////
//// PLAY VIDEO FILE IN CANVAS RELATED ROUTINES
//// src: https://www.oreilly.com/library/view/html5-canvas/9781449308032/ch06.html
////
var videoDiv;
var videoElement;
var context = null;
var Speed = 1;

var VideoList = []
var VideoIndex = 0;
async function startNextVideo() {
	if(VideoIndex < VideoList.length) {
		const path = `assets/images/${VideoList[VideoIndex]}`
		stopVideo();
		console.log("vid.333:  Stopping video and wait")
		await sleep(2000);	// wait for things to settle down

		console.log("vid.332: Starting Next Video @", path);
		videoElement.setAttribute("src", path);
		VideoIndex = VideoIndex + 1;
	}
}

// setup video file source element dynamically
//
export async function setupVideoFile(src, speed, list) {
	if(INFO.video_stopped == false) {
		stopVideo();
		console.log("setupVideoFile.276:  Video Playing, stopping video now")
		await sleep(1500);
	}

	videoDiv = document.createElement('div');
	videoElement = document.createElement("video");
	document.body.appendChild(videoDiv);
	videoDiv.setAttribute("style", "display:block");
	//videoDiv.setAttribute("style", "display:none");

	Speed = speed;
	if((src == null) && (list !== undefined)) {
		// batch process a list of videos
		VideoList = [...list];
		videoElement.addEventListener("canplaythrough",videoLoaded,false);
		videoElement.addEventListener('ended',startNextVideo,false);
		console.log("eventWindowLoaded.426:  Reached BATCH video setup...", videoElement);
		startNextVideo();
	} else {
		videoElement.setAttribute("src", src);
		videoElement.addEventListener("canplaythrough",videoLoaded,false);
		videoElement.addEventListener('progress',updateLoadingStatus,false);
		videoElement.addEventListener('ended',stopVideo,false);
		console.log("eventWindowLoaded.433:  Reached video setup...", videoElement, "  stopped=",INFO.video_stopped);
	}

}

export function stopVideo(event) {
	console.log("stop.344: INFO.video_stopped=",INFO.video_stopped);
	if(INFO.video_stopped == false) {
		INFO.video_stopped = true;

		if(videoEnded == false) {
			closeAnalyzer();
			videoEnded = true;
			if(INFO.logging_mode == true) {
				StoreConsoleLogBucket(INFO.email, INFO.uid);
				StoreHistoryBucket("INTERNAL", "666", "test");
			}
			if(INFO.record_running == true) {
				downloadFile();		// save recorded video 
			}
		}

		if(videoElement == undefined) {
			return;
		} else {
			console.log("stopVideo.122:  Clean up Video...   vdo.readyState=",videoElement.readyState, " event=", event);
			videoElement.remove();
			//clearInterval(vidIntervalID);
		}
	}
	INFO.video_stopped = true;
}


export function videoLoaded(event) {
	console.log("videoLoaded.912:  WEIRD Video LOADED!  vwd=",videoElement.videoWidth," vht=",videoElement.videoHeight);
	if(INFO.video_stopped == true) {
		console.log("videoLoaded.118:  Video LOADED!  vwd=",videoElement.videoWidth," vht=",videoElement.videoHeight);

		videoElement.style.display = "block";		// must show video element
		videoElement.style.visibility = "visible";	// must show video element
		videoElement.style.position = "absolute";
		videoElement.style.zIndex = "-1000";			// hide behind

		initAnalyzer();		// reset ball count
		canvasApp();
	} else {
		console.log("videoLoaded.310:  Video ALREADY LOADED")
	}
}

function canvasApp() {
	//if (!canvasSupport()) { return; }
	INFO.video_stopped = false;	// to prevent double start play
	videoEnded = false;		// to prevent double log dump
	//var canvas = document.getElementById("vcanvas");
	var canvas = document.getElementById(INFO.analysis_canvas);
	var context = canvas.getContext("2d");
	canvas.style.display = "inline-block";
	canvas.style.visibility = "visible";
	canvas.height = videoElement.videoHeight;
	canvas.width = videoElement.videoWidth;
	videoElement.playbackRate = Speed;	// adjust video play speed
	
	canvas.style.visibility = "hidden";
	canvas.style.display = "none";

	console.log("canvasApp.134:  PLAYING Video File NOW")
	videoElement.play();
	videoElement.muted = true;

	//vidIntervalID = setInterval(drawScreen, Math.round(1000 / frameRate));
	drawScreen();	// call it once and it calls itself
}

// NO NEED, WE JUST SEND THE CANVAS
// take a snapshot of the video and remember it
async function snapshotImage(canvas) {
	// send an image snapshot instead video canvas
	//var imageData = context.getImageData(0, 0, width, height)
	//var snapshot = new Image();
	//var snapshot = document.createElement('img'); // Use DOM HTMLImageElement
	/*
	var promise = new Promise((resolve, reject) => {
		//snapshot.crossOrigin = '';
		//snapshot.style.display = "inline-block";
		//snapshot.style.visibility = "visible";
		snapshot.onload = () => {
			resolve(snapshot);
			console.log("352 RESOLVED snapshot=");
			//analyzeImage(snapshot);
			return snapshot;
		};
		//snapshot.src = canvas.toDataURL();   // do it after define .onload()?
		//snapshot.src = 'http://www.html5canvastutorials.com/demos/assets/darth-vader.jpg'
		//snapshot = createImageBitmap(videoElement);
	})
	//return promise;
	*/

	var promise = new Promise((resolve, reject) => {
		if((INFO.video_stopped == false) && (videoElement.readyState >= 2 )) {
			console.log("356:  videoElement.readyState=",videoElement.readyState);
			try {
				const snapshot = createImageBitmap(videoElement);	// tf only takes imgBitmap
				resolve(snapshot);
				return promise;
			} catch(e) {
				reject(e)
			}
		} else {
			reject()
		}
	})
	return promise;
}


// process video image then render on canvas
async function  drawScreen () {
    var canvas = document.getElementById(INFO.analysis_canvas);
	const width = canvas.width;
	const height = canvas.height;
	if(canvas.width == 0) {
		return;
	}

	if(INFO.webcam_running == false) {
		console.log("drawScreen.210: Detected stop, clearInterval");
		clearInterval(vidIntervalID);
		return;
	}

	// take snapshot into canvas to send to AI
	//console.log("drawScreen.455: Drawing to canvas");
	context.drawImage(videoElement, 0, 0, width, height);		// this always works
	//var t0 = performance.now();
	var t0 = Date.now(); 
	TIMES.current_frame = t0;
	//displayFrameTimestamp(t0);
	await analyzeImage(canvas, t0);	// send canvas down, same as Image

	if(INFO.webcam_running == true) {
		requestAnimationFrame(drawScreen);		// daisy chain next draw
	}
	return;

	/*
	//var snapshot = await snapshotImage(canvas);
	//context.drawImage(snapshot, 0, 0, width, height);
	//var snapshot = await createImageBitmap(videoElement);
	//var snap = context.getImageData(0, 0, width, height);
	//var img2 = document.createElement('img'); // Use DOM HTMLImageElement
	//img2.src = canvas.toDataURL();   // do it after define .onload()?
	//analyzeImage(videoElement);	// this works
	//analyzeImage(snapshot);

    //TFMem("drawScreen");

	context.drawImage(videoElement, 0, 0, width, height);
	let frame = context.getImageData(0, 0, width, height);
	let l = frame.data.length / 4;		// r, g, b, a
	for (let i = 0; i < l; i++) {
		let r = frame.data[i * 4 + 0];
		let g = frame.data[i * 4 + 1];
		let b = frame.data[i * 4 + 2];
		//if (g > 60 && r > 100 && b < 43)	// if match "green"
		if (g > 60 && r > 60 && b > 60)	// if match "white"
			frame.data[i * 4 + 3] = 0;		// set transparent
	}
	context.putImageData(frame, 0, 0);
	//console.log("drawScreen.152:  Updating Video File Image")
	/*
	context.fillStyle = '#ffffaa'; //Background
	context.fillRect(0, 0, canvas.width, canvas.height);
	context.strokeStyle = '#000000';
	context.strokeRect(5,  5, (canvas.width - 10), (canvas.height - 10)); //Box
	context.drawImage(videoElement , 0, 0); //video
	*/
}

function supportedVideoFormat() {
	var video = document.createElement('video');
	var formats = [];
	var codecs = [];
	console.log("     vp9.reply=",video.canPlayType('video/webm; codecs="vp9"'));
	console.log("     vp8.reply=",video.canPlayType('video/webm; codecs="vp8"'));
	console.log("     mp4.reply=",video.canPlayType('video/webm; codecs="mp4"'));
	console.log("     ogg.reply=",video.canPlayType('video/ogg"'));
	if (video.canPlayType('video/webm; codecs="vp8"') ==="probably") {
			//return [ "webm", "vp9" ]; // [ "webm", "vp9,vp8,vorbis" ];
			formats.push("webm");
			codecs.push("vp8");
	} 
	if(video.canPlayType("video/mp4") === "probably" || 
			video.canPlayType("video/mp4") === "maybe") {
			//return [ "mp4", "avc1.42E01E, mp4a.40.2" ]; // [ "mp4", "avc1.42E01E,mp4a.40.2" ];
			formats.push("mp4");
			codecs.push("avc1.42E01E, mp4a.40.2");
	} 
	if(video.canPlayType("video/ogg") ==="probably" || 
		video.canPlayType("video/ogg") === "maybe") {
			//return [ "ogg", "theora" ]; //[ "ogg", "theora,vorbis" ];
			formats.push("ogg");
			codecs.push("");
	}
	// most preferred, push it in LAST
	if (video.canPlayType('video/webm; codecs="vp9"') ==="probably") {
			//return [ "webm", "vp8" ]; // [ "webm", "vp8,vorbis" ];
			formats.push("webm");
			codecs.push("vp9");
	} 

	return [ formats, codecs ];		// return all available
}


// video loading status
export function updateLoadingStatus() {
	var loadingStatus = document.getElementById("vloading");
	//var videoElement = document.getElementById("videofile");
	if(videoElement.buffered.length  > 0) {		// only when there is info
		var percentLoaded = parseInt(((videoElement.buffered.end(0) / videoElement.duration) * 100));
		loadingStatus.innerHTML =   percentLoaded + '%';
		//console.log("161:  Updating Video Load Progress...", percentLoaded, " %");
	}
}


// convert blob to Image
// CALL WITH: loadBlobAsImg(blob).then((img) => canvas.drawImage(img));
function loadBlobAsDataUri(blob) {
	var fileReader = new FileReader();
	var future = 
			fileReader.onLoad.first
			.then((e) => {
				return fileReader.result;
			});

	fileReader.readAsDataUrl(blob);
	return future;
}

function loadBlobAsImg(blob) {
	var image = new Image();
	return loadBlobAsDataUri(blob)
		   .then((dataUri) => {
				var loaded = image.onLoad.first;
				image.src = dataUri;
				return loaded.then((_) => image);
			});
}

